import React from "react";
import FormContainer from "shared/form";
import { FormDebug } from "shared/form/debug";
import Slider from "shared/components/slider";
import useUserProfileService from "./service";
import UserRoles from "./components/userRoles";
import { ProfileComponentProps } from "./types";
import ButtonType from "shared/enums/ButtonTypes";
import { useCopies } from "shared/hooks/useCopies";
import { useSearchParams } from "react-router-dom";
import UserProfileInfo from "./components/userInfo";
import ChangePassword from "./components/changePassword";
import { ConsoleModal } from "apps/console/enums/ConsoleModal";
import QueryParamKey from "../../../../shared/enums/QueryParamKey";
import Button from "shared/components/button";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function UserProfile() {
  const copies = useCopies();
  const [searchParams, setSearchParams] = useSearchParams();

  const closeHandler = React.useCallback(() => {
    searchParams.delete(QueryParamKey.MODAL);
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  if (searchParams.get(QueryParamKey.MODAL) !== ConsoleModal.PROFILE) {
    return null;
  }

  return (
    <Slider handleClose={closeHandler} title={copies.get("my.profile")}>
      <ProfileComponent closeHandler={closeHandler} />
    </Slider>
  );
}

function ProfileComponent(props: ProfileComponentProps) {
  const service = useUserProfileService(props);
  return (
    <FormContainer
      initialValues={service.initialValues}
      enableReinitialize
      validationSchema={service.validationSchema}
      onSubmit={service.submitHandler}>
      {() => {
        return (
          <FormContainer.Form>
            <UserProfileInfo service={service} />
            <UserRoles service={service} />
            <ChangePassword service={service} />
            <ButtonGroup fullWidth>
              <Button.Save type={ButtonType.SUBMIT} />
            </ButtonGroup>
            <FormDebug />
          </FormContainer.Form>
        );
      }}
    </FormContainer>
  );
}
